import React, { useState, useEffect } from "react";
// import axios from "axios";
import authHeader from "../src/services/auth-header";
import Navbar from "./component/Navbar";
import Body from "./component/Body";
import Maps from "./component/Maps";
import Mapsnew from "./component/Mapsnew";
import Table from "./component/Table";
import Login from "./component/Login";
// import Register from "./component/Register";
import ResetPassword from "./component/ResetPassword";
import ProtectedRoute from "../src/ProtectedRoute/ProtectedRoute";
import { Route, Switch } from "react-router-dom";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const [table, setTable] = useState([]);
  const [mapcoor, setMapcoor] = useState([]);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [done, setDone] = useState(undefined);
  const [invalidtoken, setInvalidtoken] = useState("");

  useEffect(() => {
    // axios({
    //   method: "get",
    //   url: "http://atmos.urbansciences.in/adpl/getMapImei",
    //   headers: authHeader(),
    // });
    // .then(
    //   (response) => {
    //     setTable(response.data.features);
    //     setMapcoor(response.data.features);

    //   }
    // );

    fetch("https://atmos.urbansciences.in/adpl/getMapImei", {
      method: "GET",
      headers: authHeader(),
    }) /*end fetch */
      .then((results) => results.json())
      // .then((data) => setData1(data.features))
      .then((response) => {
        setInvalidtoken(response.message);
        setTable(response.features);
        setMapcoor(response.features);
        setData1(response.features);
        // console.log(response.features)
      });

    fetch("https://atmos.urbansciences.in/adpl/getReferenceImei/username/mpcb", {
      method: "GET",
      headers: authHeader(),
    })
      .then((results) => results.json())
      .then((data) => setData2(data))
      .then((json) => setDone({ done: true }));
  }, []);

  return (
    <div>
      {(localStorage.getItem("status_code") === "201") &
        (window.location.pathname != "/atmos/maps") ? (
        <Navbar data1={data1} />
      ) : null}
      <Switch>
        <Route exact path="/atmos/login" component={Login} />
        {/* <Route exact path="/atmos/register" component={Register} /> */}
        <Route exact path="/atmos/resetpassword" component={ResetPassword} />
        <Route exact path="/atmos/maps" component={Mapsnew} />
        <ProtectedRoute
          exact
          path="/atmos/chart"
          component={Body}
          data={{ data1, data2, invalidtoken }}
        />
        <ProtectedRoute
          exact
          path="/atmos/Map"
          component={Maps}
          data={{ mapcoor, done, invalidtoken }}
        />
        <ProtectedRoute
          exact
          path="/atmos/table"
          component={Table}
          data={{ table, done, invalidtoken }}
        />
        <ProtectedRoute component={Maps} data={{ mapcoor, invalidtoken }} />
      </Switch>
    </div>
  );
}

export default App;
